/** @jsx jsx */
import { jsx } from "theme-ui"
import { ResponsiveImage } from "../../../../common"
import { ImageProps } from "../../../../../interfaces/image"
import mobileLogo from "../../../../../images/logo/mobile-logo@2x.png"

export const MobileLogo = (props: ImageProps) => (
  <ResponsiveImage src={mobileLogo} {...props} />
)
